module.exports = __webpack_public_path__ + "_assets/img/02. 稅創藝.7288db68.jpg";